module.exports = "https://cdn.redage.net/src/views/player/documets/army/images/Armylogo.png";